import script from "./esAddInstitutePersonForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./esAddInstitutePersonForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__